function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import PropTypes from 'prop-types';
import cn from "../../../utils/cn";
import { isFunction } from 'lodash';
import { fieldProps, getPreferredProp } from "../utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function CheckBoxField(props) {
  const {
    id,
    label,
    disabled = false,
    hideLabel = false,
    hint = "",
    labelPosition = "right",
    showError = true,
    showHint = true,
    required = false,
    style = {
      container: "",
      label: "",
      input: "",
      hint: "",
      error: ""
    }
  } = props;
  const onChange = e => {
    if (!disabled) {
      document.getElementById(id).focus();
      const value = e.target.checked;
      const callback = getPreferredProp(props, "onChange");
      if (isFunction(callback)) {
        callback(e);
      }
      if (isFunction(props.onChange) && props.onChange !== callback) {
        props.onChange(value);
      }
    }
  };
  const isChecked = getPreferredProp(props, "value") || getPreferredProp(props, "checked");
  const hasError = getPreferredProp(props, "invalid") && getPreferredProp(props, "touched");
  const error = getPreferredProp(props, "error") || (required ? "Required" : "");
  const inputLabelWrapperClass = cn('flex gap-2 items-center relative', {
    'flex-row-reverse': labelPosition === 'left',
    'content-end': labelPosition === 'left',
    'opacity-50': disabled
  });
  const inputClass = cn('appearance-none border w-4 h-4 focus:outline-solid-offset rounded relative shrink-0', {
    'border-medium-grey': !hasError,
    'border-red': hasError,
    'checked:bg-action-blue checked:border-action-blue': isChecked,
    'hover:bg-medium-fill-grey cursor-pointer': !disabled
  }, style.input);
  const labelClass = cn('text-sm text-text-blue font-regular-font tracking-normal', {
    'text-right': labelPosition === 'left',
    'sr-only': hideLabel,
    'cursor-pointer': !disabled
  }, style.label);
  const svgClass = cn('absolute w-4 h-4 rounded', {
    'hover:bg-deep-blue cursor-pointer': !disabled
  });
  const hintClass = cn('text-xs italic leading-4 text-medium-grey pt-1', {
    'opacity-50': disabled,
    'text-right': labelPosition === 'left'
  }, style.hint);
  const errorClass = cn('pt-1 text-red text-xs', {
    'text-right': labelPosition === 'left'
  }, style.error);
  return /*#__PURE__*/_jsx("div", {
    className: cn(style.container),
    id: "".concat(id, "-uu-checkbox-field__container"),
    "data-testid": "".concat(id, "-uu-checkbox-field__container"),
    children: /*#__PURE__*/_jsxs("div", {
      className: "w-auto inline-block",
      children: [/*#__PURE__*/_jsxs("div", {
        className: inputLabelWrapperClass,
        children: [/*#__PURE__*/_jsx("input", {
          id: id,
          "data-testid": "".concat(id, "-uu-checkbox-field__input"),
          type: "checkbox",
          checked: isChecked,
          className: inputClass,
          onChange: onChange,
          onBlur: getPreferredProp(props, "onBlur"),
          onFocus: getPreferredProp(props, "onFocus"),
          name: getPreferredProp(props, "name"),
          disabled: disabled
        }), /*#__PURE__*/_jsx("label", {
          htmlFor: id,
          className: labelClass,
          id: "".concat(id, "-uu-checkbox-field__label"),
          "data-testid": "".concat(id, "-uu-checkbox-field__label"),
          "aria-label": "".concat(label).concat(showHint && hint ? ", hint: ".concat(hint) : "", " ").concat(showError && hasError ? ", error: ".concat(error) : ""),
          children: label
        }), isChecked && /*#__PURE__*/_jsx("svg", {
          id: "".concat(id, "-uu-checkbox-field__check"),
          "data-testid": "".concat(id, "-uu-checkbox-field__check"),
          className: svgClass,
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "white",
          strokeWidth: "3",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          onClick: onChange,
          children: /*#__PURE__*/_jsx("polyline", {
            points: "20 6 9 17 4 12",
            fill: "none"
          })
        })]
      }), showHint && hint && /*#__PURE__*/_jsx("div", {
        className: hintClass,
        id: "".concat(id, "-uu-checkbox-field__hint"),
        "data-testid": "".concat(id, "-uu-checkbox-field__hint"),
        children: hint
      }), showError && hasError && /*#__PURE__*/_jsx("div", {
        className: errorClass,
        id: "".concat(id, "-uu-checkbox-field__error"),
        "data-testid": "".concat(id, "-uu-checkbox-field__error"),
        children: error
      })]
    })
  });
}
CheckBoxField.propTypes = _objectSpread({
  /** id for reference */
  id: PropTypes.string.isRequired,
  /** is checked or not */
  checked: PropTypes.bool,
  // eslint-disable-line react/no-unused-prop-types
  /** Override the inline-styles of the elements with tailwind style || **Not Recommended** */
  style: PropTypes.shape({
    container: PropTypes.string,
    button: PropTypes.string,
    hint: PropTypes.string,
    label: PropTypes.string,
    toggle: PropTypes.string,
    wrapper: PropTypes.string
  }),
  /** Should the label be hidden? */
  hideLabel: PropTypes.bool,
  /** label text for button */
  label: PropTypes.string.isRequired,
  /** Position of the label */
  labelPosition: PropTypes.oneOf(["right", "left"]),
  /** Is the input disabled? */
  disabled: PropTypes.bool,
  /** Help text displayed below the input */
  hint: PropTypes.node,
  /** Show Error HTML defaults to true */
  showError: PropTypes.bool,
  /** Show Hint HTML defaults to true */
  showHint: PropTypes.bool,
  /** is required or not */
  required: PropTypes.bool
}, fieldProps);
export default CheckBoxField;
//# sourceMappingURL=CheckBoxField.js.map